import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import moment from "moment";
import {confirmAlert} from "react-confirm-alert";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Tooltip from "@material-ui/core/Tooltip";
import {Link} from "react-router-dom";
import CollectionOverride from "components/CollectionOverride";
import UniversalModalOverride from "../UniversalModalOverride";
import {Objects} from "../index";

const {getFullID} = Framework.Utilities;

export default class DispositionPendingsKiosks extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Dispositions_Pendings._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = 'GET_EDITING';
		this.limit = 5;
		this.state.limit = 5;
	}

	handleLockDevice = (kiosks) => {
		this.props.handleSetPin(1, false, false, kiosks.pkey,
			kiosks.binary_id,
			kiosks.location,
			kiosks.location_binary_id);
	}
	
	componentDidMount() {
		setTimeout(() => {
			if(this.state.data[0].dl_scan_toggle) {
				this.handleToggleShowDLModal(this.state.data[0].binary_id + '-' + this.state.data[0].pkey)
			}
		}, 1000);
	}


	handleRemoveFromKiosk = async (e) => {
		this.model.object.pkey = parseInt(e.currentTarget.id);
		this.model.object.binary_id = e.currentTarget.getAttribute('binary_id');

		try {
			await this.model.submit(null, "POST_REMOVE");
			this.reloadTable();
		} catch (error) {
		}

		this.model.object.pkey = '';
		this.model.object.binary_id = '';
		this.props.reloadPage();
	};
	// copied from src/components/Collections/DispositionPendingsFirearms.js
	handleDelete = (e) => {
		const pkey = parseInt(e.currentTarget.id);
		const binary_id = e.currentTarget.getAttribute('binary_id');

		confirmAlert({
			title: 'Confirm Delete',
			message: 'Are you sure you want to delete this Pending 4473?',
			buttons: [
				{
					label: 'Yes',
					color: 'danger',
					onClick: async () => {
						this.model.object.pkey = pkey;
						this.model.object.binary_id = binary_id;

						try {
							await this.model.submit(null, API.RequestType.DELETE);
							this.reloadTable();
						} catch (error) {
						}

						this.model.object.pkey = '';
						this.model.object.binary_id = '';
						this.props.reloadPage();
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}


	handleToggleShowDLModal = async (id) => {
		if(typeof id !== 'undefined') {
			this.state.currID = id.split('-')[1];
			this.state.currBID = id.split('-')[0];
		}
		else  {
			let DLmodel = new API.BuildClass(Types.Dispositions_Pendings._name, API.RequestType.UPDATE);
			this.state.dl_scan_toggle = false;
			this.state.pkey = this.state.currBID + '-' + this.state.currID;
			await DLmodel.submit(this, API.RequestType.UPDATE, null, true);
		}
		this.setState({showDLmodal: !this.state.showDLmodal});
	}

	handleDLmodalSubmit = () => {
		this.handleToggleShowDLModal();
		this.reloadTable();
	}


	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width:125,
				Cell: props => {
					return (
						<Button
							id={props.original.pkey}
							data-cy={`kiosk-${props.original.name_first+props.original.name_last}`}
							binary_id={props.original.binary_id}
							color="blue-hoki"
							size={"sm"}
							block={true}
							onClick={()=>this.handleLockDevice(props.original.kiosks)}>
							Launch Kiosk <i className={"fa fa-arrow-right"}/>
						</Button>

					);
				}
			},

			{
				Header: "ID",
				id: "pkey",
				width: 120,
				/** @param {Dispositions_Pendings_Object} obj */
				accessor: obj => obj.binary_id + '-' + obj.pkey
			},
			{
				Header: "Date",
				id: "date",
				width: 100,
				/** @param {Dispositions_Pendings_Object} obj */
				accessor: obj => obj.date ? moment(obj.date).local().format("MM/DD/YYYY") : '-'
			},
			{
				Header: "Kiosk",
				id: "kiosk",
				width: 200,
				/** @param {Dispositions_Pendings_Object} obj */
				accessor: obj => obj.kiosks.name || ''
			},
			{
				Header: "Name",
				id: "name_first",
				/** @param {Dispositions_Pendings_Object} obj */
				accessor: (obj) => `${obj.name_first} ${(obj.name_middle === 'NMN' ? '' : obj.name_middle + ' ')}${obj.name_last}`,
				// Cell: (props) => {
				// 	let {original} = props;
				// 	return (
				// 		<Link to={`/customers/${getFullID(original, 'customer')}`}>
				// 			{`${original.name_first} ${(original.name_middle === 'NMN' ? '' : original.name_middle + ' ')}${original.name_last}`}
				// 		</Link>
				// 	);
				// }
			},
			{
				Header: "Address",
				id: "street_1",
				/** @param {Dispositions_Pendings_Object} obj */
				accessor: obj => (obj.street_1 + " " + (obj.street_2 ? obj.street_2 + " " : "") + obj.city + " " + obj.state + " " + obj.zip)
			},
			{
				Header: "Product(s)",
				id: "disposition_pending_items.serial_number",
				sortable: false,
				/** @param {Dispositions_Pendings_Object|Products_Object} obj */
				accessor: obj => {
					//obj.serial_number ? (obj.type + ' | ' + (obj.manufacturers ? obj.manufacturers.name : obj.manufacturer_other) + ' | ' + obj.model + ' | ' + obj.serial_number) : ''
					return obj.disposition_pending_itemss.map(entry => entry.products.serial_number)?.toString()
				}
			},
			{
				Header: "Birth Date",
				id: "birth_date",
				width: 100,
				/** @param {Dispositions_Pendings_Object} obj */
				accessor: obj => {
					return obj.birth_date ? moment(obj.birth_date).local().format("MM/DD/YYYY") : '-'
				}
			},
			{

				Header: "DL Scan",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 130,
				/** @param {Dispositions_Pendings_Object} props.original */
				Cell: props => {
					return (
						<Button
							onClick={() => this.handleToggleShowDLModal(props.original.binary_id + '-' + props.original.pkey)}
							color={'blue-hoki'} size={"sm"} block={true}>
							<i className={"fa fa-automobile"}/> DL Scan
						</Button>
					)}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<Tooltip title={"Cancel Edit"}>
						<Button
							id={props.original.pkey}
							binary_id={props.original.binary_id}
							color="danger"
							size={"sm"}
							block={true}
							onClick={this.handleRemoveFromKiosk}>
							 <i className={"fa fa-times-circle"}/>
						</Button>
						</Tooltip>
					);
				}
			},
			// {
			// 	Header: "",
			// 	className: "button-cell",
			// 	filterable: false,
			// 	sortable: false,
			// 	width: 40,
			// 	Cell: props => {
			// 		return (
			// 			<span>
			// 				<Button
			// 					id={props.original.pkey}
			// 					binary_id={props.original.binary_id}
			// 					color="danger"
			// 					size={"sm"}
			// 					block={true}
			// 					onClick={this.handleDelete}>
			// 					<i className={"fa fa-trash"}/>
			// 				</Button>
			// 			</span>
			// 		);
			// 	}
			// },

		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							<h5 style={{margin: '8px 0 0', fontWeight: 'normal'}}>
								Kiosk Editing 4473s
							</h5>
							{this.renderHeaderRight("Kiosk Editing 4473s", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<UniversalModalOverride
						locations={this.props.locations}
						kiosks={this.props.kiosks}
						states={this.props.states}
						history={this.props.history}
						id={this.state.currID}
						binary_id={this.state.currBID}
						title={"Waiting for Drivers License Barcode Scan"}
						objectProps={{
							mytoggle: this.handleDLmodalSubmit
						}}
						object={Objects.DriversLicenseScan}
						showModal={this.state.showDLmodal}
						handleToggle={() => this.handleToggleShowDLModal()}
						afterSave={this.handleAfterSave}
						hideGoTo={true}
						cancelLabel={"Close"}
						submitLabel={"Save"}
					/>


					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
